import { Button, Grid } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { DealerQuotesStatus, FullQuotationDataFragment, PreviewUserDataFragment } from '../../../../api';
import OutlinedMultiSelectField from '../../../../components/fields/OutlinedMultiSelectField';
import useInviteQuoteData from './hooks/useInviteQuoteData';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        actionButton: {
            width: 240,
            maxWidth: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            [theme.breakpoints.up('sm')]: {
                marginLeft: 0,
                marginRight: 0,
            },
        },
        actionButtonContainer: {
            display: 'flex',
            justifyContent: 'center',
            [theme.breakpoints.up('sm')]: {
                justifyContent: 'flex-start',
            },
        },
    })
);

export type AuthorisationForLowerQuoteProps = {
    quotation: FullQuotationDataFragment;
    onSubmit: () => void;
};

const AuthorisationForLowerQuote = ({ quotation, onSubmit }: AuthorisationForLowerQuoteProps) => {
    const { t } = useTranslation(['purchaseTransactionsPage', 'common']);
    const { dealers } = useInviteQuoteData();
    const styles = useStyles();
    const quotedDealerIds = new Set(
        (quotation.dealersInfo ?? [])
            .filter(dealerInfo => dealerInfo.status === DealerQuotesStatus.Quoted)
            .map(dealerInfo => dealerInfo.dealerId)
    );
    const quotedDealers = dealers.filter(
        dealer => quotedDealerIds.has(dealer.id) && quotation.entries?.some(entry => entry.dealerId === dealer.id)
    );

    return (
        <Grid container>
            <Grid xs={12} item>
                <OutlinedMultiSelectField<PreviewUserDataFragment>
                    color="secondary"
                    getOptionLabel={dealer => dealer.fullName}
                    label={t('quotation.dealerQuotes.title')}
                    name="lowerQuoteDealerIds"
                    noOptionsText={t('common:noDealers')}
                    options={quotedDealers}
                    placeholder={t('common:searchDealers')}
                    renderOption={dealer => dealer.fullName}
                />
            </Grid>
            <Grid className={styles.actionButtonContainer} style={{ marginTop: '6px' }} xs={12} container item>
                <Button
                    className={styles.actionButton}
                    color="secondary"
                    onClick={onSubmit}
                    style={{ fontWeight: 'bold' }}
                    type="submit"
                    variant="outlined"
                >
                    {t('purchaseTransactionsPage:quotation.authorisationForLowerQuote.sendWANotificationToRequote')}
                </Button>
            </Grid>
        </Grid>
    );
};

export default AuthorisationForLowerQuote;
